import { Component, Input, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule, InfoIcon } from 'lucide-angular';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import type { Producto } from '../../../types/product.types';
import { PopoverModule } from 'primeng/popover';

@Component({
  selector: 'allas-core-deposit',
  standalone: true,
  imports: [CommonModule, LucideAngularModule, ButtonModule, PopoverModule],
  template: `
    <div class="flex items-center gap-2 text-sm text-gray-500 italic">
      <span> +L.{{ getFormattedDeposit() }} Depósito Reembolsable </span>
      <button
        (mouseenter)="popover.show($event)"
        (mouseleave)="popover.hide()"
        class="inline-flex items-center justify-center w-4 h-4 rounded-full bg-gray-300 hover:bg-gray-400 transition-colors"
        type="button"
        aria-label="Información sobre depósito reembolsable"
      >
        <lucide-icon [name]="infoIcon" class="w-3 h-3 text-gray-600" />
      </button>
    </div>

    <!-- Help Dialog -->
    <p-popover #popover [style]="{ width: '300px' }">
      <ng-template pTemplate="content">
        <h3 class="text-sm font-bold">¿QUÉ ES?</h3>

        <div class="text-gray-700 leading-relaxed text-xs mt-2">
          <p class="mb-2">
            Para las baterías, puedes devolver tu batería y nosotros te ayudamos
            a reciclarla, de esta forma nos ayudas a reducir el costo del
            producto, así como a ayudar en los esfuerzos de reciclaje que
            benefician al medio ambiente.
            <br />
            <strong>
              Cuando la parte vieja es devuelta a Allas Repuestos, te
              reembolsamos el cargo del núcleo.
            </strong>
          </p>
        </div>
      </ng-template>
    </p-popover>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class CoreDeposit {
  @Input() product!: Producto;

  readonly infoIcon = InfoIcon;
  showHelpDialog = false;

  getFormattedDeposit(): string {
    if (!this.product?.precio) return '0.00';

    const deposit = this.product.precio * 0.06; // 6% del precio
    return deposit.toFixed(2);
  }
}
